// SHADOW MARKET™ — 9 products (3 types × 3 colors). Hardcoded catalog.
// Prices here are visual ONLY; the backend re-validates from PRICES in
// /app/backend/routes/shadow_market.py before any Stripe session is created.

export const PRODUCTS = [
  {
    id: "polo-black",
    slug: "polo-rebel-black",
    type: "polo",
    name: "POLO RE\u20BFEL\u2122",
    subtitle: "Piqu\u00e9 premium \u00b7 Logo bordado \u00b7 Fit slim",
    price: 49.90, proPrice: 42.41,
    color: "VOID BLACK", colorHex: "#050508",
    badge: "PREMIUM", badgeBg: "#f5a623", badgeText: "#0a0800",
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: [],
    details: [
      "Piqu\u00e9 algod\u00f3n 220gsm",
      "Logo RE\u20BFEL\u2122 bordado en pecho",
      "Cuello y pu\u00f1os ribeteados",
      "Fit slim moderno",
      "Lavado a m\u00e1quina 30\u00b0",
    ],
    isNew: false, isFeatured: true, accentColor: "#00d4ff",
  },
  {
    id: "polo-grey", slug: "polo-rebel-grey", type: "polo",
    name: "POLO RE\u20BFEL\u2122",
    subtitle: "Piqu\u00e9 premium \u00b7 Logo bordado \u00b7 Fit slim",
    price: 49.90, proPrice: 42.41,
    color: "CONCRETE GREY", colorHex: "#3a3a3a",
    badge: null,
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: ["XS"],
    details: [
      "Piqu\u00e9 algod\u00f3n 220gsm",
      "Logo RE\u20BFEL\u2122 bordado en pecho",
      "Cuello y pu\u00f1os ribeteados",
      "Fit slim moderno",
      "Lavado a m\u00e1quina 30\u00b0",
    ],
    isNew: false, isFeatured: false, accentColor: "#00d4ff",
  },
  {
    id: "polo-cream", slug: "polo-rebel-cream", type: "polo",
    name: "POLO RE\u20BFEL\u2122",
    subtitle: "Piqu\u00e9 premium \u00b7 Logo bordado \u00b7 Fit slim",
    price: 49.90, proPrice: 42.41,
    color: "CREAM", colorHex: "#e8e4d8",
    badge: "NEW", badgeBg: "#00e676", badgeText: "#021208",
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: [],
    details: [
      "Piqu\u00e9 algod\u00f3n 220gsm",
      "Logo RE\u20BFEL\u2122 bordado en pecho",
      "Cuello y pu\u00f1os ribeteados",
      "Fit slim moderno",
      "Lavado a m\u00e1quina 30\u00b0",
    ],
    isNew: true, isFeatured: false, accentColor: "#00d4ff",
  },
  {
    id: "pantalon-black", slug: "pantalon-rebel-black", type: "pantalon",
    name: "PANTAL\u00d3N RE\u20BFEL\u2122",
    subtitle: "Tejido t\u00e9cnico \u00b7 Fit relaxed \u00b7 Logo lateral",
    price: 38.90, proPrice: 33.07,
    color: "VOID BLACK", colorHex: "#050508",
    badge: "LIMITED", badgeBg: "transparent", badgeText: "#ff3355", badgeBorder: "#ff3355",
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: ["XS","XXL"],
    details: [
      "Tejido t\u00e9cnico ligero",
      "Bolsillos laterales con cremallera",
      "Logo RE\u20BFEL\u2122 serigraf\u00eda lateral",
      "Cord\u00f3n ajustable",
      "Fit relaxed \u2014 ideal para verano",
    ],
    isNew: false, isFeatured: true, accentColor: "#f5a623",
  },
  {
    id: "pantalon-grey", slug: "pantalon-rebel-grey", type: "pantalon",
    name: "PANTAL\u00d3N RE\u20BFEL\u2122",
    subtitle: "Tejido t\u00e9cnico \u00b7 Fit relaxed \u00b7 Logo lateral",
    price: 38.90, proPrice: 33.07,
    color: "CONCRETE GREY", colorHex: "#3a3a3a",
    badge: null,
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: [],
    details: [
      "Tejido t\u00e9cnico ligero",
      "Bolsillos laterales con cremallera",
      "Logo RE\u20BFEL\u2122 serigraf\u00eda lateral",
      "Cord\u00f3n ajustable",
      "Fit relaxed \u2014 ideal para verano",
    ],
    isNew: false, isFeatured: false, accentColor: "#f5a623",
  },
  {
    id: "pantalon-cream", slug: "pantalon-rebel-cream", type: "pantalon",
    name: "PANTAL\u00d3N RE\u20BFEL\u2122",
    subtitle: "Tejido t\u00e9cnico \u00b7 Fit relaxed \u00b7 Logo lateral",
    price: 38.90, proPrice: 33.07,
    color: "CREAM", colorHex: "#e8e4d8",
    badge: "NEW DROP", badgeBg: "#00e676", badgeText: "#021208",
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: [],
    details: [
      "Tejido t\u00e9cnico ligero",
      "Bolsillos laterales con cremallera",
      "Logo RE\u20BFEL\u2122 serigraf\u00eda lateral",
      "Cord\u00f3n ajustable",
      "Fit relaxed \u2014 ideal para verano",
    ],
    isNew: true, isFeatured: false, accentColor: "#f5a623",
  },
  {
    id: "camiseta-black", slug: "camiseta-rebel-black", type: "camiseta",
    name: "CAMISETA RE\u20BFEL\u2122",
    subtitle: "220gsm \u00b7 Logo serigraf\u00eda \u00b7 Fit boxy",
    price: 19.90, proPrice: 16.92,
    color: "VOID BLACK", colorHex: "#050508",
    badge: "NEW DROP", badgeBg: "#00e676", badgeText: "#021208",
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: [],
    details: [
      "Algod\u00f3n 220gsm peinado",
      "Logo RE\u20BFEL\u2122 serigraf\u00eda pecho",
      "\u201cREBELBTC.COM\u201d en espalda",
      "Fit boxy moderno",
      "Cuello reforzado",
    ],
    isNew: true, isFeatured: true, accentColor: "#00e676",
  },
  {
    id: "camiseta-grey", slug: "camiseta-rebel-grey", type: "camiseta",
    name: "CAMISETA RE\u20BFEL\u2122",
    subtitle: "220gsm \u00b7 Logo serigraf\u00eda \u00b7 Fit boxy",
    price: 19.90, proPrice: 16.92,
    color: "CONCRETE GREY", colorHex: "#3a3a3a",
    badge: null,
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: ["XXL"],
    details: [
      "Algod\u00f3n 220gsm peinado",
      "Logo RE\u20BFEL\u2122 serigraf\u00eda pecho",
      "\u201cREBELBTC.COM\u201d en espalda",
      "Fit boxy moderno",
      "Cuello reforzado",
    ],
    isNew: false, isFeatured: false, accentColor: "#00e676",
  },
  {
    id: "camiseta-cream", slug: "camiseta-rebel-cream", type: "camiseta",
    name: "CAMISETA RE\u20BFEL\u2122",
    subtitle: "220gsm \u00b7 Logo serigraf\u00eda \u00b7 Fit boxy",
    price: 19.90, proPrice: 16.92,
    color: "CREAM", colorHex: "#e8e4d8",
    badge: "PREMIUM", badgeBg: "#f5a623", badgeText: "#0a0800",
    sizes: ["XS","S","M","L","XL","XXL"], soldOutSizes: [],
    details: [
      "Algod\u00f3n 220gsm peinado",
      "Logo RE\u20BFEL\u2122 serigraf\u00eda pecho",
      "\u201cREBELBTC.COM\u201d en espalda",
      "Fit boxy moderno",
      "Cuello reforzado",
    ],
    isNew: false, isFeatured: false, accentColor: "#00e676",
  },
];

export const PRODUCT_TYPES = [
  { key: "polo",     label: "POLOS",      price: 49.90, accent: "#00d4ff" },
  { key: "pantalon", label: "PANTALONES", price: 38.90, accent: "#f5a623" },
  { key: "camiseta", label: "CAMISETAS",  price: 19.90, accent: "#00e676" },
];

export const SIZE_GUIDE = [
  { size: "XS",  pecho: 86,  largo: 68, cintura: 72 },
  { size: "S",   pecho: 91,  largo: 70, cintura: 76 },
  { size: "M",   pecho: 96,  largo: 72, cintura: 80 },
  { size: "L",   pecho: 101, largo: 74, cintura: 84 },
  { size: "XL",  pecho: 107, largo: 76, cintura: 88 },
  { size: "XXL", pecho: 114, largo: 78, cintura: 92 },
];

export const PRO_DISCOUNT_PCT = 15;
export const FREE_SHIPPING_THRESHOLD = 100;
export const SHIPPING_COST = 4.95;

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const getProductsByType = (type) =>
  type === "all" ? PRODUCTS : PRODUCTS.filter((p) => p.type === type);
export const getVariantsOfType = (type) =>
  PRODUCTS.filter((p) => p.type === type);
